<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #195905" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #195905">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.vat_percentage')"
            v-model="data.tax"
            required
          />

          <base-input
            type="number"
            col="6"
            :placeholder="$t('PLACEHOLDERS.app_commission_from_order')"
            v-model="data.commission_admin"
            required
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSetting",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        tax: null,
        commission_admin: null,
        commission_provider: null,
        payment_amount: null,
        request_period_day: null,
        points_per_join: null,
        point_value_per_sar: null,
      },
    };
  },
  methods: {
    async getDataToEdit() {
      try {
        let res = await this.$axios.get(
          "settings-general?key=dashboard_setting"
        );
        const settings = res.data.data.data[0].value;
        this.data.tax = settings.tax;
        this.data.commission_admin = settings.commission_admin;
        this.data.commission_provider = settings.commission_provider;
        this.data.payment_amount = settings.Payment_amount;
        this.data.request_period_day = settings.Request_period_day;
        this.data.points_per_join = settings.Points_every_joining;
        this.data.point_value_per_sar = settings.Points_value_per_riyal;
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "dashboard_setting");
      REQUEST_DATA.append("value[tax]", this.data.tax);
      REQUEST_DATA.append(
        "value[commission_admin]",
        this.data.commission_admin
      );
      REQUEST_DATA.append(
        "value[commission_provider]",
        this.data.commission_provider
      );
      REQUEST_DATA.append("value[Payment_amount]", this.data.payment_amount);
      REQUEST_DATA.append(
        "value[Request_period_day]",
        this.data.request_period_day
      );
      REQUEST_DATA.append(
        "value[Points_every_joining]",
        this.data.points_per_join
      );
      REQUEST_DATA.append(
        "value[Points_value_per_riyal]",
        this.data.point_value_per_sar
      );
      try {
        await this.$axios.post("settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    validateFormInputs() {
      const tax = Number(this.data.tax);
      const commission = Number(this.data.commission_admin);

      if (this.data.tax === null || this.data.tax === "") {
        this.$message.error(this.$t("VALIDATION.tax"));
        return;
      }
      if (
        this.data.commission_admin === null ||
        this.data.commission_admin === ""
      ) {
        this.$message.error(this.$t("VALIDATION.commission_admin"));
        return;
      }
      if (isNaN(tax) || tax < 0 || tax > 100) {
        this.$message.error(this.$t("VALIDATION.percentage_range"));
        return;
      }
      if (isNaN(commission) || commission < 0 || commission > 100) {
        this.$message.error(this.$t("VALIDATION.percentage_range"));
        return;
      }
      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>
